import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalStateContext } from './GlobalState';

const StepNavigation = ({ currentStep = 0, showGuide, setShowGuide }) => {
  const navigate = useNavigate();
  const { isLoggedInSpotify } = useContext(GlobalStateContext);
  
  const steps = [
    { id: 'builder', label: 'Load', path: '/builder' },
    { id: 'filter', label: 'Filter&Sort', path: '/mixandsave' },
    { id: 'save', label: 'Save', path: '/save' },
    { id: 'player', label: 'Player', path: '/player' }
  ];

  // Determine the URL based on login state
  const ssRootUrl = isLoggedInSpotify ? `${window.location.origin}/logout` : `${window.location.origin}/login-home`;

  return (
    <div className="bg-black text-white pb-4 fixed-top w-100" style={{ zIndex: 1030 }}>
      <div className="container px-4" style={{ maxWidth: '550px', margin: '0 auto' }}>
      {/* Top App Bar */}
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom border-secondary bg-black">
        <button 
          onClick={() => navigate('/')}
          className="btn btn-dark rounded-circle"
        >
          <i className="home icon"></i>
        </button>

        <span className="h4 mb-0">
          Song2Run
        </span>

        <div className="d-flex gap-2">
          <button
            onClick={() => navigate('/guide')}
            className="btn btn-dark rounded-circle"
          >
            <i className="question circle icon"></i>
          </button>
          
          <a 
          href={ssRootUrl}
          className="btn btn-dark rounded-circle"
        >
          {isLoggedInSpotify ? (
            <i className="sign-out icon"></i>
          ) : (
            <i className="sign-in icon"></i>
          )}
        </a>
        </div>
      </div>

      {/* Step Indicator */}
      <div className="px-4 py-3">
        <div className="position-relative d-flex justify-content-between mx-2">
          {/* Connection line */}
          <div className="position-absolute w-100 top-50" style={{
            height: '2px',
            backgroundColor: '#6c757d',
            transform: 'translateY(-50%)',
            zIndex: 1
          }} />

          {/* Steps */}
          {steps.map((step, index) => (
            <div key={step.id} className="d-flex flex-column align-items-center position-relative">
              <div 
                className={`rounded-circle d-flex align-items-center justify-content-center ${
                  index === currentStep ? '' : 'bg-secondary'
                }`}
                style={{
                  width: '48px',
                  height: '48px',
                  zIndex: 2,
                  cursor: 'pointer',
                  backgroundColor: index === currentStep ? '#FC8E18' : undefined
                }}
                onClick={() => navigate(step.path)}
              />
              <span className={`
                mt-2 small
                ${index === currentStep ? 'text-white' : 'text-secondary'}
              `}>
                {step.label}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Title */}
      {/*
      currentStep === 0 && (
        
        <h1 className="h2 px-4">
          Load some songs
        </h1>
        
      )
        */}
      </div>
    </div>
  );
};

export default StepNavigation;
